<template>
  <v-text-field
      :error-messages="error"
      :label="translation(translationList.email, 'Email')"
      v-model="email"
      :rules="emailValidationRules"
      name="email"
      variant="outlined"
      :tile="true"
      :readonly="isReadonly"
  >
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
    customerIndex: Number as () => number | null,
    isReadonly: Boolean as () => boolean | null,
  },
  setup(props, { emit }) {
    const { modelValue, customerIndex, isReadonly } = toRefs(props);
    const email = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    watch(modelValue, (newValue) => {
      email.value = newValue;
    });

    watch(email, (newValue) => {
      const valueToValidate = newValue || '';
      const isValid = validateEmail(valueToValidate);
      emit('update:modelValue', valueToValidate);
      if (customerIndex.value !== undefined) {
        emit('validation-customer-status', { field: `email-${customerIndex.value}`, isValid });
      } else {
        emit('validation-customer-status', { field: `email`, isValid });
      }
    });

    watch(modelValue, (newValue) => {
      if (newValue && validateEmail(newValue)) {
        email.value = newValue;
      }
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const emailValidationRules = [
      (v: string) => !!v || translation(translationList.value.required, 'Acest câmp este obligatoriu'),
      (v: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    function validateEmail(email: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        if (!email) {
          error.value = [translation(translationList.value.required, 'Acest câmp este obligatoriu')];
          return false;
        }
      }
      const result = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (showErrors) {
        if (!result) {
          error.value = [translation(translationList.value.invalid_field, 'Acest câmp este invalid.')];
          return false;
        }
      }
      return result;
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validateEmail(email.value);
      if (customerIndex.value !== undefined) {
        emit('validation-customer-status', { field: `email-${customerIndex.value}`, isValid });
      } else {
        emit('validation-customer-status', { field: `email`, isValid });
      }

      // Listen for validate events
      window.addEventListener('validate-customer', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && (data.detail === `email-${customerIndex.value}` || data.detail === `email`)) {
        const isValid = validateEmail(email.value, true);
        if (isValid) {
          emit('validation-customer-status', { field: 'email', isValid });
        }
      }
    };

    return {
      email,
      emailValidationRules,
      translationList,
      translation,
      error,
      isReadonly,
    };
  },
});
</script>

<style scoped>
</style>